<style scoped>
.loader {
position: absolute;
top :0;
left: 0;
right: 0;
bottom: 0;
margin: auto;
}
</style>

<template lang="pug">
  .main-content-padded
    .row
      .col
        .bcrumb
          a Subscriber
      .col.s12.m12
        table.striped
          thead
            tr
              th.table-header.sortable
                | Name
              th.table-header.sortable
                | Number of Contacts
          tbody
            //- tr
            tr(v-for='(clist, index) in contactList.lists')
              td
                router-link(:to="`/Newsletter-subscibers/${clist.name}/${clist.id}`" ) {{clist.name}}
              td {{clist.uniqueSubscribers}}
            div.preloader-wrapper.big.active.loader(v-if='!contactList.lists')
              div.spinner-layer.spinner-green-only
                div.circle-clipper.left
                  div.circle
                div.gap-patch
                  div.circle
                div.circle-clipper.right
                  div.circle


            //- p.title.medium.grey-text.center-align Nothing to Show

</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  meta: {
    title: 'Newsletter Subscribers'
  },
  data () {
    return {
      subcriber: [],
      contactList: []
    }
  },
  mounted () {
    this.getContactList()
  },
  filters: {
    date: function (val) {
      return moment(val).format('MMM DD, YYYY')
      // return moment(val).format('MMM DD, YYYY, h:mm:ss a')
    }
  },
  computed: {},
  methods: {
    getSubscibers () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-list/newsletter`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.subcriber = result.data
          })
      })
    },
    getContactList () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-get-contact-groups`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.contactList = result.data
            console.log(result);
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-newsletter-subscribers.vue